import { PREFERENCE_KEY } from "../enums/preference-key.enum";

export const mockPreferencesInfo = [
  {
    user_id: "123",
    preference_key: PREFERENCE_KEY.CONSENT_BANNER,
    active: true,
  },
  {
    user_id: "123",
    preference_key: PREFERENCE_KEY.HIDE_ON_DASHBOARD,
    active: false,
  },
];
